import React from "react";
import { IconButton, TouchableRipple, useTheme } from "react-native-paper";
import { toHuman } from "../../utils/money";
import { nanoid } from "nanoid/non-secure";
import { ThemeType } from "../../theme/theme";
import { Text } from "../text/text";
import { DataTable } from "../data-table";
import { convertPstDateIntoLocalTime } from "../../utils/date";
import { I18nManager, StyleSheet, View, Image } from "react-native";
import { Box } from "../layout/box";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Spacer } from "../spacer/spacer";
import { Stack } from "../layout/stack";
import { spacing } from "../../theme/spacing";

const ITEMS_PER_PAGE = 6;

interface IServiceRequestsTableParams {
  serviceRequests: any[];
  networkError: string;
  onRowPressHandler: Function;
  isLoading: boolean;
}

export const ServiceRequestTable = ({ serviceRequests = [], networkError, isLoading, onRowPressHandler, networkErrorTx }: IServiceRequestsTableParams) => {
  const theme = useTheme() as ThemeType;
  const { fontSize, colors, iconSize } = theme;
  const [page, setPage] = React.useState(0);
  const from = page * ITEMS_PER_PAGE;
  const to = (page + 1) * ITEMS_PER_PAGE;
  const isFirstEmpty = Boolean(serviceRequests && serviceRequests.length === 1 && typeof serviceRequests[0].category_description === "undefined");
  const noServiceRequestsAvailable = Boolean((!serviceRequests?.length || isFirstEmpty) && !isLoading);
  const styles = StyleSheet.create({
    text: {
      fontSize: fontSize.large,
      color: colors.darkGrey,
      textAlign: "center",
    },
    noTransactionsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginVertical: spacing.large,
    },
    noTransactionsIcon: {
      height: iconSize.massive,
      width: iconSize.massive,
      resizeMode: "contain",
      marginBottom: spacing.smaller,
    },
  });

  // Using a component here for future network-error use case
  const NoServiceRequestsTable = ({ titleTx, paragraphTx, children }: any) => (
    <Stack space="small" style={styles.noTransactionsContainer}>
      {children}
      <Text tx={titleTx} style={[styles.text, { fontWeight: "bold" }]} />
      <Text tx={paragraphTx} style={styles.text} />
    </Stack>
  );

  if (networkError && !isLoading) {
    const paragraphTx = typeof networkErrorTx === "string" ? networkErrorTx : "homeStack.noConnectionParagraph";
    return (
      <NoServiceRequestsTable
        titleTx="homeStack.noConnectionTitle"
        paragraphTx={paragraphTx}>
        <Image
          source={require("../../../assets/network-error.png")}
          style={styles.noTransactionsIcon}
        />
      </NoServiceRequestsTable>
    );
  }

  if (noServiceRequestsAvailable) {
    return (
      <NoServiceRequestsTable
        titleTx="serviceStack.noServiceRequestsTitle"
        paragraphTx="serviceStack.noServiceRequestsParagraph">
        <Image
          source={require("../../../assets/empty-transactions.png")}
          style={styles.noTransactionsIcon}
        />
      </NoServiceRequestsTable>
    );
  }

  return (
    <DataTable
      isLoading={isLoading}
      headers={['Date', 'Category', 'Status']}
      data={serviceRequests.map((serviceRequest: any, index: number) => {
        const { reported_date, category_description, status } = serviceRequest;
        return {
          key: index,
          col1: convertPstDateIntoLocalTime(reported_date).format("M/DD/YY"),
          col2: category_description,
          col3: status,
          onPress: () => onRowPressHandler(serviceRequest),
        }
      })}
    />
  );
};